import Audits from './Audits';
import Models from './Models';
import HostDetails from './HostDetails';
import RegistrationCommands from './RegistrationCommands';
import HostStatuses from './HostStatuses';
import EmptyPage from './common/EmptyPage/route';

export const routes = [
  Audits,
  Models,
  HostDetails,
  RegistrationCommands,
  HostStatuses,
  EmptyPage,
];



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/routes.js